module.exports = __webpack_public_path__ + "static/media/StrikeBlue.e0305d7d.svg";